import { useContext } from 'react';
import { ThemeContext, ThemeContextType } from '../context/ThemeContextType';

/**
 * Custom hook to access theme context
 * @returns Theme context object with theme state and toggle function
 */
export const useAppTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useAppTheme must be used within a ThemeProvider');
  }
  return context;
};